import http from "../http-common";

class ProctorService {
  createProctor(data) {
    return http.post(`/api/proctor`, data);
  }
  getProctors(data) {
    return http.get(`/api/proctor`+'?year=' + data.year + '&term=' + data.term + '&exam_type=' + data.exam_type + '&proctor_id=' + data.proctor_id+ '&examination_schedule_id=' + data.examination_schedule_id);
  }
  getAllProctor() {
    return http.get(`/api/proctor/getAllProctor`);
  }
  getProctorByFilter(data) {
    return http.get(`/api/proctor/getProctorByFilter?fullname=`+data.fullname+'&&faculty_id='+data.faculty_id+'&&course_id='+data.course_id);
  }
  getProctor(id) {
    return http.get(`/api/proctor/` + id);
  }
  updateProctor(id, data) {
    return http.put(`/api/proctor/${id}`, data);
  }
  updateProctormaxS(id, data) {
    return http.put(`/api/proctor_maxS/${id}`, data);
  }
  createProctorMaxS(data){
    return http.post(`/api/proctor_maxS`, data);
  }
  deleteProctorMaxS(data){
    return http.delete(`/api/proctor_maxS`+'?year=' + data.year + '&term=' + data.term + '&exam_type=' + data.exam_type);
  }
}

export default new ProctorService();